import Marquee from "react-fast-marquee";

const WORDS = ["Discretion", "Governance", "People Risk", "Advisory", "Transformation", "Leadership", "Compliance", "Investigations"];

export function Ribbon() {
  return (
    <div data-testid="editorial-marquee" className="py-8 border-y border-white/10 bg-surface">
      <Marquee speed={30} gradient gradientColor="#111111" gradientWidth={120}>
        {WORDS.concat(WORDS).map((w, i) => (
          <span key={i} className="font-mono text-sm tracking-[0.25em] uppercase text-gold/80 mx-8 flex items-center">
            {w} <span className="text-gold ml-8">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
